import React from "react";
import "../css/CareerLife.css";

const CareerLife = () => {
  const images = [
    "/images/a.jpeg",
    "/images/img1.jpg",
    "/images/primary.jpg",
    "/images/school03.jpg",
  ];

  const scrollToPositions = () => {
    const element = document.getElementById("open-positions-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="career-footer-sections">
      {}
      <section className="life-at-school">
        <h2>Life at Our School</h2>
        <p className="subtitle">Moments, Learning & Growth Together</p>
        <div className="life-gallery">
          {images.map((img, index) => (
            <div key={index} className="gallery-item">
              <img src={img} alt={`Life at Sahara ${index + 1}`} />
            </div>
          ))}
        </div>
      </section>

      {}
      <section className="career-cta">
        <div className="cta-content">
          <h2>Inspire. Educate. Grow With Us.</h2>
          <p>
            At Sahara Public School, we believe great teachers build great
            futures. Join our passionate community and make a meaningful impact
            in students' lives.
          </p>
          <div className="cta-buttons">
            <button className="btn-white" onClick={scrollToPositions}>
              View Open Positions
            </button>
            <button className="btn-outline" onClick={scrollToPositions}>
              Get in touch
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CareerLife;
